<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--two">
          <div class="filterItem">
            <span class="searchText">UID</span>
            <el-input
              class="filterControl"
              placeholder="输入用户 UID"
              prefix-icon="el-icon-search"
              :value="uid"
              size="small"
              clearable
              @input="$emit('update:uid', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">状态</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="status"
              placeholder="全部状态"
              size="small"
              clearable
              filterable
              @change="$emit('update:status', $event)"
            >
              <el-option label="待审核" :value="0" />
              <el-option label="审核通过" :value="1" />
              <el-option label="审核失败" :value="2" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiRoleMemoryReviewListFilterPanel',
  props: {
    uid: { type: String, default: '' },
    status: { type: [String, Number], default: '' },
    activeFilterCount: { type: Number, default: 0 },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
</style>
